jQuery.feature_import("js-order-app-config",
    () => require("./OrderAppConfig.tsx"),
    mod => mod.feature_js_order_app_config
);